import styled from "styled-components";
import stars from "../../../assets/stars.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MainContainer = styled.section`
  min-width: 100vw;
  min-height: 100vh;
  height: max-content;
  display: flex;
  justify-content: center;
  background-image: url(${stars});
  background-color: rgb(86, 41, 182);
`;
const SubContainer = styled.div`
  width: 80vw;
  min-width: 90vw;
  height: fit-content;
  min-height: 70vh;
  margin: 10vh 0px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 5vw;
  row-gap: 10vh;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 0;
  }
`;
const ContentWrapper = styled.div`
  width: 500px;
  height: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 0;
    min-height: fit-content;
    margin-bottom: 40px;
    & .chatBotSvg {
      height: 200px;
    }
  }
`;
const FormWrapper = styled.div`
  width: fit-content;
  height: 100%;
  min-height: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 3px;
  border-radius: 2px;
  margin-bottom: 16px;
`;
const FormColumn = styled.div`
  height: fit-content;
  padding: 15px 20px;
`;
const FormRow = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
`;
const Title = styled.h2`
  color: white;
  font-size: 16px;
  font-weight: 400;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const FormInput = styled.input`
  padding: 4px 12px;
  color: #000040;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  display: block;
  border: 1px solid #000040;
  border-radius: 6px;
  width: 220px;
  height: 30px;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
  margin-bottom: 16px;

  &:focus {
    border-color: #000040;
    box-shadow: 0 0 8px rgba(0, 0, 64, 0.2);
  }

  &::placeholder {
    color: #999;
  }

  input&:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
  }
`;

const FormInputLabel = styled.label`
  width: 220px;
  color: #000040; /* Premium dark blue */
  text-transform: uppercase;
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.8px;
  padding: 4px 8px;
  margin-bottom: 4px;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #1a1a80; /* Slightly lighter shade for hover effect */
  }
`;

const FormInputSelect = styled.select`
  padding: 6px 10px;
  margin: 15px 0 16px 0;
  color: #000040; /* Premium dark blue */
  font-size: 16px;
  font-weight: 500;
  outline: none;
  display: block;
  width: 100%;
  height: 40px;
  background: #fff;
  border: 2px solid #000040; /* Dark blue border for a premium feel */
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    border-color: #1a1a80; /* Lighter shade on hover */
  }

  &:focus {
    border-color: #1a1a80;
    box-shadow: 0 0 5px rgba(0, 0, 64, 0.3); /* Subtle glow effect */
  }

  &:first-child {
    margin-top: 0;
  }
`;

const FormInputSelectOption = styled.option`
  color: #000040; /* Premium dark blue */
  font-size: 14px;
  font-weight: 500;
  background: #f8f9fa; /* Light gray background */
  padding: 10px;

  &:hover {
    background: #e0e0e0; /* Slightly darker background on hover */
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;

const ButtonSuccessLarge = styled.button`
  text-transform: uppercase;
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgb(60, 204, 56) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(255, 255, 255) !important;
  display: block;
  width: 100%;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgb(46, 166, 42) none repeat scroll 0% 0%;
  }
`;

const ButtonSuccess = styled.button`
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: #ff0000 none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(255, 255, 255) !important;
  display: block;
  width: fit-content;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: #000040 none repeat scroll 0% 0%;
  }
`;

const ButtonSecondaryLarge = styled.button`
  text-transform: uppercase;
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(136, 136, 136) !important;
  display: block;
  width: 100%;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  }
`;

const ButtonSecondary = styled.button`
  font-weight: 600;
  border: 0px none;
  border-radius: 30px;
  position: relative;
  transition: all 0.3s ease 0s;
  outline: currentcolor none 0px;
  padding: 7px 20px;
  background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  font-size: calc(13px);
  color: rgb(136, 136, 136) !important;
  display: block;
  width: fit-content;
  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: rgba(0, 0, 0, 0.05) none repeat scroll 0% 0%;
  }
`;

const FormFooterLink = styled.div`
  text-align: center;
  box-sizing: border-box;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  font-size: 13px !important;
  line-height: 1.53846;
  text-rendering: optimizelegibility;
  &:hover a {
    color: inherit;
    text-decoration: none;
  }
  }
`;

// side bar components
const SideBarMainContainer = styled.div`
  width: ${props => props.isExpanded ? '250px' : '60px'};
  min-height: 100vh;
  height: max-content;
  display: flex;
  position: fixed;
  flex-direction: column;
  justify-content: space-between;
  background-color: #000040;
  z-index: 99;
  transition: width 0.3s ease-in-out;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
`;

const SideBarSubContaienr = styled.div`
  width: 100%;
  min-height: min-content;
  display: flex;
  flex-direction: column;
`;

const SideBarListedItems = styled.ul`
  width: 100%;
  height: 46px;
  padding: 5px 10px 5px 0px;
  color: #a189d7;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
  transition: all 0.3s ease-in-out;
  &:hover {
    cursor: pointer;
    color: white;
    & #active {
      background-color: white;
    }
  }
`;

const SideBarActiveListedItems = styled.div`
  display: block;
  width: 5px;
  height: 100%;
`;

// common
// min-height = viewPortHeight-header-marginTop-marginBotton
const BoxWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 8px 8px 4px 8px;
  padding: 8px 8px 12px 8px;
  /* Removed fixed min-height to allow natural growth */
  height: auto;
  flex: 1 0 auto;
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 3px;
  background-color: rgb(255, 255, 255);
  overflow-x: hidden;
  overflow-y: visible;
`;
// Header Components
const HeaderMainContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  position: fixed;
  justify-content: space-between;
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 3px;
  background-color: rgb(255, 255, 255);
  z-index: 98;
`;
const HeaderNav = styled.nav`
  width: fit-content;
  display: flex;
  align-items: center;
`;
const UserIcon = styled.div`
  width: 26px;
  height: 26px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(86, 41, 182);
  border-radius: 13px;
  margin: 10px 10px 10px 0px;
`;
const IconWhiteHover = styled.div`
  display: flex;
  margin: 7px 14px;
  color: #000040;
  &:hover {
    cursor: pointer;
    color: #67757e;
  }
`;
const SubHeading = styled.h2`
  color: #67757e;
  font-style: Roboto, sans-serif;
  font-size: 15px;
`;
const HeaderUserContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 10px;
  top: 45px;
  width: fit-content;
  height: fit-content;
  background-color: wheat;
  min-width: 100px;
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 3px;
  background-color: rgb(255, 255, 255);
`;
const HeaderUserNavMain = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 20px;
`;
const HeaderUserNavSub = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-top: 1px solid rgb(233, 236, 239);
  &:hover {
    background-color: rgb(240, 240, 240);
    cursor: pointer;
    & #LogoutIcon {
      color: #67757e;
    }
  }
`;

// Page Initiators
const PrimeMainContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  position: relative;
  overflow-x: hidden;
`;

const SubMainContainer = styled.div`
  width: calc(100% - ${props => props.isExpanded ? '250px' : '60px'});
  min-height: 100vh;
  margin-left: ${props => props.isExpanded ? '250px' : '60px'};
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 0 10px;
`;

const MainWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 45px);
  height: auto;
  margin-top: 45px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  position: relative;
  overflow-x: hidden;
  overflow-y: visible;
  padding: 0px;
`;

// Model Components
const MainModelContainer = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgb(255, 255, 255, 0.5);
  position: fixed;
  z-index: 99;
`;

const ModelContainer = styled.div`
  min-width: 500px;
  max-width: 700px;
  height: fit-content;
  display: flex;
  justify-content: center;
  border-radius: 20px;
`;
const ModelTitleWrapper = styled.div`
  padding: 15px 40px;
  background-color: #000040;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
`;
const ModelContentWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
`;
const ModelBoxWrapper = styled.div`
  width: calc(100vw - 58px - 16px - 16px);
  box-shadow: rgb(0 0 0 / 15%) 0px 0px 20px 3px;
  background-color: rgb(255, 255, 255);
  overflow: hidden;
`;

// please wait common component
const PleaseWaitMainContainer = styled.div`
  background-color: white;
  opacity: 0.8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;
const CircularLoading = styled.div`
  margin: 10px;
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top: 8px solid rgb(86, 41, 182);
  width: 50px;
  height: 50px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const StyledDatePicker = styled(DatePicker)`
  padding: 0px 0px 3px;
  color: rgb(57, 60, 64);
  font-size: 16px;
  outline: currentcolor none 0px;
  display: block;
  border-style: none none solid;
  border-width: medium medium 1px;
  width: 200px;
  height: 34px;
  background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
  transition: all 0.3s ease 0s;
  margin-bottom: 16px;
`;

const styles = {
  MainContainer,
  SubContainer,
  ContentWrapper,
  FormWrapper,
  FormColumn,
  FormRow,
  Title,
  Form,
  FormInput,
  FormInputLabel,
  FormInputSelect,
  FormInputSelectOption,
  ButtonWrapper,
  ButtonSuccess,
  ButtonSecondary,
  ButtonSuccessLarge,
  ButtonSecondaryLarge,
  FormFooterLink,
  IconWhiteHover,
  // Main Page Initiator
  PrimeMainContainer,
  SubMainContainer,
  MainWrapper,
  // side bar components
  SideBarMainContainer,
  SideBarSubContaienr,
  SideBarListedItems,
  SideBarActiveListedItems,
  //
  // header components
  BoxWrapper,
  HeaderMainContainer,
  HeaderNav,
  SubHeading,
  HeaderUserContainer,
  HeaderUserNavMain,
  HeaderUserNavSub,
  UserIcon,
  // Model Components
  MainModelContainer,
  ModelContainer,
  ModelTitleWrapper,
  ModelContentWrapper,
  ModelBoxWrapper,
  // PleaseWait
  PleaseWaitMainContainer,
  CircularLoading,
  // DatePicker
  StyledDatePicker,
};
export default styles;
